import React from "react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { AboutUs } from "../components/landing/AboutUs";
import { MissionVision } from "../components/landing/MissionVision";
import { Values } from "../components/landing/Values";
import { Services } from "../components/landing/Services";
import { Clients } from "../components/landing/Clients";
import { Contact } from "../components/landing/Contact";
import { Footer } from "../components/landing/Footer";
import { Toaster } from "../components/ui/sonner";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-white text-[#022140] selection:bg-[#72B3E4] selection:text-[#022140]"
    >
      <Navbar />
      <main>
        <Hero />
        <AboutUs />
        <MissionVision />
        <Values />
        <Services />
        <Clients />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
